"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOrderById = exports.useParseOrderUi = void 0;
var moment_1 = __importDefault(require("moment"));
var react_1 = require("react");
var context_1 = require("../context/context");
var utils_1 = require("../utils");
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var query_1 = require("./query");
var hooks_1 = require("./hooks");
var useParseOrderUi = function (order) {
    var _a;
    var config = (_a = (0, context_1.useTwapContext)()) === null || _a === void 0 ? void 0 : _a.config;
    var estimatedDelayBetweenChunksMillis = (0, hooks_1.useEstimatedDelayBetweenChunksMillis)();
    return (0, react_1.useMemo)(function () {
        if (!config || !order)
            return;
        var srcToken = order.srcToken, dstToken = order.dstToken, srcAmount = order.srcAmount, srcBidAmount = order.srcBidAmount, dstMinAmount = order.dstMinAmount, srcFilledAmount = order.srcFilledAmount, fillDelay = order.fillDelay, createdAt = order.createdAt, deadline = order.deadline, dollarValueOut = order.dollarValueOut, progress = order.progress;
        if (!srcToken || !dstToken)
            return;
        var isMarketOrder = (0, bignumber_js_1.default)(dstMinAmount || 0).lte(1);
        var srcChunkAmountUi = (0, utils_1.amountUiV2)(srcToken.decimals, srcBidAmount) || "0";
        var dstMinAmountOutUi = (0, utils_1.amountUiV2)(dstToken.decimals, dstMinAmount) || "0";
        var dstAmount = (0, utils_1.amountUiV2)(dstToken.decimals, order.dstAmount) || "0";
        var srcFilledAmountUi = (0, utils_1.amountUiV2)(srcToken.decimals, srcFilledAmount) || "0";
        var totalChunks = order.totalChunks || 0;
        return {
            id: order.id,
            createdAt: createdAt,
            createdAtUi: (0, moment_1.default)(createdAt * 1000).format("ll HH:mm"),
            deadlineUi: (0, moment_1.default)(deadline * 1000).format("ll HH:mm"),
            isMarketOrder: isMarketOrder,
            srcAmountUi: (0, utils_1.amountUiV2)(srcToken.decimals, srcAmount) || "0",
            srcAmountUsdUi: order.dollarValueIn || "0",
            srcChunkAmountUi: srcChunkAmountUi,
            srcFilledAmountUi: srcFilledAmountUi,
            dstMinAmountOutUi: dstMinAmountOutUi,
            fillDelay: (fillDelay || 0) * 1000 + estimatedDelayBetweenChunksMillis,
            deadline: deadline * 1000,
            prefix: isMarketOrder ? "~" : "~",
            dstAmount: dstAmount,
            dstAmountUsd: dollarValueOut || "0",
            progress: progress,
            srcToken: srcToken,
            dstToken: dstToken,
            totalChunks: totalChunks,
            status: order.status,
            txHash: order.txHash,
            limitPrice: isMarketOrder ? undefined : (0, bignumber_js_1.default)(dstMinAmountOutUi).div(srcChunkAmountUi).toString() || "0",
            excecutionPrice: (0, bignumber_js_1.default)(dstAmount).gt(0) && (0, bignumber_js_1.default)(srcFilledAmountUi).gt(0) ? (0, bignumber_js_1.default)(dstAmount).div(srcFilledAmountUi).toString() : undefined,
        };
    }, [config, order, estimatedDelayBetweenChunksMillis]);
};
exports.useParseOrderUi = useParseOrderUi;
var useOrderById = function (id) {
    var data = query_1.query.useOrdersHistory().data;
    var order = (0, react_1.useMemo)(function () {
        if (!data)
            return;
        return Object.keys(data)
            .flatMap(function (key) { return data[key]; })
            .find(function (it) { return it.id === id; });
    }, [data, id]);
    return (0, exports.useParseOrderUi)(order);
};
exports.useOrderById = useOrderById;
